package cz.lhoracek.mapl.ui.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import qrcode.QRCode

@Composable
fun QrCodeImage(
    content: String,
    modifier: Modifier = Modifier,
    size: Dp = 240.dp,
    darkColor: Color = Color.Black,
    lightColor: Color = Color.White,
) {
    val matrix = remember(content) {
        QRCode.ofSquares().build(content).rawData
    }

    Canvas(modifier = modifier.size(size)) {
        val cellSize = this.size.width / matrix.size

        // background
        drawRect(lightColor, size = this.size)

        matrix.forEachIndexed { row, cols ->
            cols.forEachIndexed { col, cell ->
                if (cell.dark) {
                    drawRect(
                        color = darkColor,
                        topLeft = Offset(col * cellSize, row * cellSize),
                        size = Size(cellSize, cellSize),
                    )
                }
            }
        }
    }
}
